import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'upgrade.form.header',
    defaultMessage: 'Experience the full benefits of the Counselor Community',
  },
  contactInformation: {
    id: 'upgrade.form.contactInformation',
    defaultMessage: 'Verify your contact information below',
  },
  connect: {
    id: 'upgrade.form.connect',
    defaultMessage: 'Connect with and message high school counselors',
  },
  exportContactInformation: {
    id: 'upgrade.form.export.contact.information',
    defaultMessage: 'Export valuable contact information',
  },
  staffAccounts: {
    id: 'upgrade.form.staffAccounts',
    defaultMessage: 'Create unlimited staff accounts',
  },
  followingInstitution: {
    id: 'upgrade.form.followingInstitution',
    defaultMessage: 'See who is following your institution',
  },
  previewCollegeProfile: {
    id: 'upgrade.form.preview.college.profile',
    defaultMessage: 'Preview your College Profile as seen by students',
  },
  searchCapabilities: {
    id: 'upgrade.form.searchCapabilities',
    defaultMessage: 'Utilize advanced search capabilities',
  },
  findHighSchool: {
    id: 'upgrade.form.findHighSchool',
    defaultMessage: 'Find high school counselors using advanced search features',
  },
  joinGroups: {
    id: 'upgrade.form.joinGroups',
    defaultMessage: 'Join groups and collaborate within the Community',
  },
  requestInformation: {
    id: 'upgrade.form.requestInformation',
    defaultMessage: 'Request Information',
  },
  closingCount: {
    id: 'upgrade.form.closing',
    defaultMessage: 'Closing in {count, number} secs..',
  },
  thanksTitle: {
    id: 'upgrade.form.thanksTitle',
    defaultMessage: 'Thanks!',
  },
  thanksMessage: {
    id: 'upgrade.form.thanksMessage',
    defaultMessage: 'We\'ll be reaching out to you soon.',
  },
  connectAlt: {
    id: 'upgrade.form.connectAlt',
    defaultMessage: 'Connect with high school counselors',
  },
  staffAccountsAlt: {
    id: 'upgrade.form.staffAccountsAlt',
    defaultMessage: 'Unlimited staff accounts',
  },
  followingInstitutionAlt: {
    id: 'upgrade.form.followingInstitutionAlt',
    defaultMessage: 'See who is following',
  },
  searchCapabilitiesAlt: {
    id: 'upgrade.form.searchCapabilitiesAlt',
    defaultMessage: 'Search capabilities',
  },
  joinGroupsAlt: {
    id: 'upgrade.form.joinGroupsAlt',
    defaultMessage: 'Join groups and collaborate',
  },
  successAlt: {
    id: 'upgrade.form.successAlt',
    defaultMessage: 'We will be in touch shortly',
  },
  enterValue: {
    id: 'upgrade.form.error.missingValue',
    defaultMessage: 'Please enter a value',
  },
  firstName: {
    id: 'upgrade.form.firstName',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'upgrade.form.lastName',
    defaultMessage: 'Last Name',
  },
  email: {
    id: 'upgrade.form.emailAddress',
    defaultMessage: 'Email',
  },
  invalidEmail: {
    id: 'upgrade.form.error.emailInvalid',
    defaultMessage: 'Invalid email address',
  },
  phone: {
    id: 'upgrade.form.phone',
    defaultMessage: 'Phone',
  },
  invalidPhone: {
    id: 'upgrade.form.error.phoneInvalid',
    defaultMessage: 'Invalid phone number',
  },
  company: {
    id: 'upgrade.form.company',
    defaultMessage: 'Institution',
  },
  notes: {
    id: 'upgrade.form.message',
    defaultMessage: 'Please provide more information to help us better route your request.',
  },
  hobsonsCommunication: {
    id: 'upgrade.form.optIn',
    defaultMessage: 'Receive Intersect communications related to product news, promotions, event updates, and company announcements.',
  },
  formErrors: {
    id: 'upgrade.form.errors',
    defaultMessage: 'There are form errors',
  },
  note: {
    id: 'upgrade.note',
    defaultMessage: 'Note: Upgrades are available for U.S. and Canadian based institutions only.',
  },
  unlockPowerfulFeatures: {
    id: 'upgrade.form.unlockPowerfulFeatures',
    defaultMessage: 'Unlock powerful features',
  },
  jobLevel: {
    id: 'upgrade.form.job.level',
    defaultMessage: 'Job Level',
  },
  jobTopic: {
    id: 'upgrade.form.job.topic',
    defaultMessage: 'Are you interested in upgrading to a paid subscription or support for an existing subscription?',
  },
});

export default messages;
